import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { updateFields } from '../../redux/actions';
import SettingsCardComponent from './settings-card-component';

const mapStateToProps = (state: ApplicationState) => ({
  t: state.i18n.t
});

export default connect(mapStateToProps, { updateFields })(SettingsCardComponent);
